export default {
  fastcompany: {
    siteName: 'Fast Company',
    slug: 'fastcompany',
    url: 'https://www.fastcompany.com',
    slogan: 'The Future Of Business',
    description:
      "Fast Company is the world's leading progressive business media brand, with a unique editorial focus on innovation in technology, leadership, and design.",
    favicon: '/favicon.ico',
    logo:
      'https://fast-company-res.cloudinary.com/image/upload/v1480632834/fast-company-share-graphic.png',
    keywords: [
      'business',
      'magazine',
      'news',
      'leadership',
      'most innovative companies',
      'most creative people',
      'videos',
      'innovation'
    ],
    facebook: {
      fanpageId: '5942134076',
      appId: '178479832213933',
      appAdminId: '100000062710915'
    },
    krux: {
      id: 'J53aqF_f'
    },
    omniture: {
      server: 'fastcompany',
      trackingPixel:
        '//grunerandjahr.112.2o7.net/b/ss/gjincfastcoprod/1/H.24.4--NS/0/5658306',
      scode:
        '//assets.fastcompany.com/assets/js/vendor/omniture/omniture-scode-prod.js'
    },
    parsely: {
      domain: 'fastcompany.com'
    },
    facebookPixel: {
      id: 475240032660076
    },
    nielsen: {
      clientId: 'us-805310h'
    },
    googleAnalytics: {
      webPropertyId: 'UA-4300461-2',
      rollupPropertyId: 'UA-4300461-33'
    },
    comscore: {
      c1: 2,
      c2: 6916907,
      publisherId: 6916907
    },
    chartbeat: {
      uid: 2768,
      domain: 'fastcompany.com'
    },
    pingdom: {
      id: '518c1737abe53dc44c000000'
    }
  },
  fastcodesign: {
    siteName: 'Co.Design',
    slug: 'fastcodesign',
    url: 'https://www.fastcodesign.com',
    slogan: 'Where Design, Business, And Technology Collide',
    description:
      'Inspiring stories about innovation and business, seen through the lens of design.',
    favicon: '/favicon.ico',
    logo:
      'http://fast-company-res.cloudinary.com/image/upload/v1481312788/fcweb/codesign-share-graphic.png',
    keywords: [
      'innovation',
      'ethonomics',
      'graphics',
      'innovation by design',
      'interactive',
      'product',
      'spaces',
      'world changing ideas'
    ],
    facebook: {
      fanpageId: '107619279310824',
      appId: '123388861116012',
      appAdminId: '100000062710915'
    },
    krux: {
      id: 'J53bAWi-'
    },
    omniture: {
      server: 'fastcodesign',
      trackingPixel:
        '//grunerandjahr.112.2o7.net/b/ss/gjincfastcoprod/1/H.24.4--NS/0/5658306',
      scode:
        '//assets.fastcompany.com/assets/js/vendor/omniture/omniture-scode-prod.js'
    },
    parsely: {
      domain: 'fastcodesign.com'
    },
    facebookPixel: {
      id: 475240032660076
    },
    nielsen: {
      clientId: 'us-805310h'
    },
    googleAnalytics: {
      webPropertyId: 'UA-4300461-6',
      rollupPropertyId: 'UA-4300461-33'
    },
    comscore: {
      c1: 2,
      c2: 6916907,
      publisherId: 6916907
    },
    chartbeat: {
      uid: 2768,
      domain: 'fastcodesign.com'
    },
    pingdom: {
      id: '51955434abe53d9a09000000'
    }
  },
  fastcoexist: {
    siteName: 'Co.Exist',
    slug: 'fastcoexist',
    url: 'https://www.fastcoexist.com',
    slogan: 'Ideas + Impact',
    description:
      'News, infographics, and videos about the future of energy, electric cars, the environment, and food on FastCoExist.com.',
    favicon: '/favicon.ico',
    logo:
      'https://fast-company-res.cloudinary.com/image/upload/v1486509739/fcweb/nuhdjevddtnssijoz8qa.png',
    keywords: [
      'ideas',
      'impact',
      'future',
      'environment',
      'sustainability',
      'green solar power',
      'futurist',
      'sustainability',
      'science',
      'ideas',
      'cities',
      'transportation'
    ],
    facebook: {
      fanpageId: '227383110655483',
      appId: '180431352040909',
      appAdminId: '100000062710915'
    },
    krux: {
      id: 'J53a0_W3'
    },
    omniture: {
      server: 'fastcoexist',
      trackingPixel:
        '//grunerandjahr.112.2o7.net/b/ss/gjincfastcoprod/1/H.24.4--NS/0/5658306',
      scode:
        '//assets.fastcompany.com/assets/js/vendor/omniture/omniture-scode-prod.js'
    },
    parsely: {
      domain: 'fastcoexist.com'
    },
    facebookPixel: {
      id: 475240032660076
    },
    nielsen: {
      clientId: 'us-805310h'
    },
    googleAnalytics: {
      webPropertyId: 'UA-4300461-17',
      rollupPropertyId: 'UA-4300461-33'
    },
    comscore: {
      c1: 2,
      c2: 6916907,
      publisherId: 6916907
    },
    chartbeat: {
      uid: 2768,
      domain: 'fastcoexist.com'
    },
    pingdom: {
      id: '518c1737abe53dc44c000000'
    }
  },
  fastcocreate: {
    siteName: 'Co.Create',
    slug: 'fastcocreate',
    url: 'https://www.fastcocreate.com',
    slogan: 'Creativity + Culture + Commerce',
    description:
      'Creativity in the converging worlds of advertising, entertainment, and technology.',
    favicon: '/favicon.ico',
    logo:
      'https://fast-company-res.cloudinary.com/image/upload/v1486509645/fcweb/e67pjfiszeseogrdmhbz.png',
    keywords: [
      'creativity',
      'culture',
      'commerce',
      'advertising',
      'marketing',
      'brand',
      'campaigns',
      'commercial',
      'ad agency',
      'ads',
      'interactive',
      'movies',
      'music',
      'tv'
    ],
    facebook: {
      fanpageId: '321331447886601',
      appId: '1563945053870390',
      appAdminId: '100000062710915'
    },
    krux: {
      id: 'J6xtVoFS'
    },
    omniture: {
      server: 'fastcocreate',
      trackingPixel:
        '//grunerandjahr.112.2o7.net/b/ss/gjincfastcoprod/1/H.24.4--NS/0/5658306',
      scode:
        '//assets.fastcompany.com/assets/js/vendor/omniture/omniture-scode-prod.js'
    },
    parsely: {
      domain: 'fastcocreate.com'
    },
    facebookPixel: {
      id: 475240032660076
    },
    nielsen: {
      clientId: 'us-805310h'
    },
    googleAnalytics: {
      webPropertyId: 'UA-4300461-20',
      rollupPropertyId: 'UA-4300461-33'
    },
    comscore: {
      c1: 2,
      c2: 6916907,
      publisherId: 6916907
    },
    chartbeat: {
      uid: 2768,
      domain: 'fastcocreate.com'
    },
    pingdom: {
      id: '518c1737abe53dc44c000000'
    }
  }
};



// WEBPACK FOOTER //
// ./src/server/config/analytics.js